// @flow
import * as React from 'react';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { mr } from 'styled-components-spacing';
import theme from '@theme';

const { colors } = theme;

export const CheckboxContainer = styled.div`
  min-width: ${props => (props.smallCheck ? '20px' : '40px')};
  min-height: ${props => (props.smallCheck ? '20px' : '40px')};
  box-sizing: content-box !important;
  border: ${props => (props.showid === 'show-map' ? '0px' : '1px')} solid ${
  colors.translucentDarkBlue
};
${({ noBorder }) => noBorder && 'border: none'};
  background-color: ${props =>
    (props.bgColor || props.treatmentFormName ? colors.white : colors.lightGray)};
  cursor: pointer;
  ${mr(3)}

  ${props =>
    (props.checked
      ? `
       #${props.showid}{
      display: flex;
      }
    `
      : `
      #${props.showid}{
      display: none;
    }
  `)}

  ${breakpoint('mobile', 'desktop')`
    border-radius: 10px;
  `}

  ${breakpoint('desktop')`
    border-radius: ${props => (props.treatmentFormName || !props.smallCheck ? '10px' : '3px')};
  `}
`;

export const Icon = styled(({ ...rest }) => <FontAwesomeIcon {...rest} />)`
  height: ${props => (props.smallCheck ? '14px' : '20px')};
  font-size: 20px;
  color:${props => (props.formDoctor ? '#0FA958' : colors.navyGray)}
`;

export const StyledCheckbox = styled.div`
  width: ${props => (props.smallCheck ? '20px' : '40px')};
  background-color: inherit;
  height: ${props => (props.smallCheck ? '20px' : '40px')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: inherit;
`;
